import { apiBasePath, apiConfigurationFactory } from '@/api/utils/auth.provider';
import { DictionaryApi } from '@/generated/api/fps/api';

export interface Bank {
  id: string;
  aliases: string[];
  name: string;
  icon: string;
  steps: string[];
  detailsLink?: string;
}

const dictionaryApi = new DictionaryApi(apiConfigurationFactory('auth'));

export const queryBanks = async (ignoreSteps = true): Promise<Bank[]> => {
  const { banks } = await dictionaryApi.dictionaryControllerBanks(ignoreSteps);
  return banks.map(({ bankId, label, icon, ...bank }) => ({
    ...bank,
    id: bankId,
    name: label,
    icon: `${apiBasePath}/img/banks/${icon}`,
  }));
};
